import React from 'react';

import styles from './Breadcrumbs.module.scss';

export default function Breadcrumbs({ children }) {
  return <nav className={styles.breadcrumbs}>{children}</nav>;
}
